import { searchCashBoxesBrowse } from "../../../api/accounts.service";
import { useAccountTypeBrowse } from "../../../hooks/useAccountTypeBrowse";
import { CASH_BOX_ACCOUNT_TYPE } from "./cash-boxes.constants";

export function useCashBoxesBrowse() {
  return useAccountTypeBrowse({
    accountType: CASH_BOX_ACCOUNT_TYPE,
    searchBrowse: searchCashBoxesBrowse,
  });
}
